import { queryOptions } from '@tanstack/react-query';
import { PdpEvaluationDTO } from '@/types/models';
import { client } from '@/api/client';
export const getPdpEvaluation = async (id: string): Promise<PdpEvaluationDTO> => {
  try {
    const result = await client.get(`/plans/${id}/evaluation`);
    return result.data.data;
  } catch (error) {
    return {} as PdpEvaluationDTO;
  }
};
export const pdpEvaluationOptions = (id: string) => queryOptions({
  queryKey: ['pdp-evaluation', id],
  queryFn: () => getPdpEvaluation(id)
});